import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Wizard, Button, Form, useWizardContext } from '@lounge-fe/ui-kit'
import { brandSchema } from '../schema'
import { StepLayout } from '../StepLayout'
import { StepActions } from '../StepActions'
import { useFittingRoomContext } from '../FittingRoomProvider'

export const CurrentBrand = () => {
  const { t } = useTranslation()
  const { next } = useWizardContext()
  const [isLoungeCurrentBrand, setIsLoungeCurrentBrand] = useState(true)
  const { competitors } = useFittingRoomContext()

  const hasCompetitors = competitors.length > 0

  return (
    <Wizard.Step validationSchema={brandSchema}>
      <StepLayout
        title={t('fitting_room.current_brand.title')}
        subtitle={t('fitting_room.current_brand.subtitle')}
      >
        <div className="flex flex-col gap-y-4">
          <Button
            variant="outline"
            type="button"
            className="h-full min-h-[48px] py-4 rounded-sm border-[#E5E5E5]"
            onClick={() => next({ currentBrand: null })}
          >
            {t('fitting_room.current_brand.choice_yes')}
          </Button>
          <Button
            variant="outline"
            type="button"
            className="h-full min-h-[48px] py-4 rounded-sm border-[#E5E5E5]"
            onClick={() =>
              hasCompetitors
                ? setIsLoungeCurrentBrand(false)
                : next({ currentBrand: null })
            }
          >
            {t('fitting_room.current_brand.choice_no')}
          </Button>
        </div>
        {!isLoungeCurrentBrand && (
          <>
            <div className="flex flex-col my-4 gap-y-2">
              <Form.Select
                name="currentBrand"
                options={competitors.map(({ name }) => ({
                  value: name,
                  label: name,
                }))}
                label={t('fitting_room.current_brand.select_label')}
                placeholder={t('fitting_room.current_brand.select_placeholder')}
              />
            </div>
            <StepActions />
          </>
        )}
      </StepLayout>
    </Wizard.Step>
  )
}
